import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import {
  grantConsent,
  denyConsent,
  hasConsent,
  requiresConsent,
  initIfReady,
} from '@/lib/analytics';

export function ConsentBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const needConsent = requiresConsent();
    const stored = hasConsent();

    if (!needConsent) {
      initIfReady();
      return;
    }
    if (stored) {
      if (stored === 'granted') initIfReady();
      return;
    }
    setOpen(true);
  }, []);

  const onAllow = () => {
    grantConsent();
    setOpen(false);
  };

  const onDeny = () => {
    denyConsent();
    setOpen(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Help us improve Vent</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              We use Mixpanel to understand how the app is used so we can make it
              better. We never send your name, email, or anything you write — only
              anonymous events like &quot;Vent Posted&quot; tied to a random ID.
            </p>
            <p className="text-sm text-muted-foreground">
              You can change this anytime in{' '}
              <Link to="/app/settings" className="underline">
                Settings &rarr; Privacy
              </Link>
              . Read our{' '}
              <Link to="/privacy" className="underline">
                Privacy Policy
              </Link>{' '}
              for details.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDeny}>No thanks</AlertDialogCancel>
          <AlertDialogAction onClick={onAllow}>Allow analytics</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
